import type { IconData } from '@stacksjs/iconify-core'

export const musicMicrophone2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M24.38 10.67h-1.52V3.05h-1.53v13.71h1.53v-4.57h1.52v6.1h1.52V9.15h-1.52zm-1.52 7.62h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.53h-1.53Zm-1.52-3.05h1.52v1.53h-1.52Zm0-15.23h1.52v1.52h-1.52Zm-9.14 19.81v1.52h4.57v4.57h-4.57v1.53H7.62V32h16.76v-3.04h-3.05v-1.53h-4.57v-4.57h4.57v-1.52zm7.62-13.72h1.52v1.53h-1.52Zm0-3.05h1.52V6.1h-1.52Zm-6.1 13.72h7.62v1.52h-7.62Zm3.05-9.14h1.52v1.52h-1.52Zm0-3.05h1.52v1.52h-1.52Zm0-3.05h1.52v1.52h-1.52ZM12.19 0h7.62v1.53h-7.62Zm0 7.62h1.52v1.53h-1.52Zm0-3.05h1.52V6.1h-1.52Z\"/><path fill=\"currentColor\" d=\"M10.67 16.76h1.52v1.53h-1.52Zm0-15.23h1.52v1.52h-1.52ZM9.14 19.81h1.53v1.53H9.14Zm-1.52-1.52h1.52v1.52H7.62Zm0-6.1h1.52v4.57h1.53V3.05H9.14v7.62H7.62V9.15H6.1v9.14h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default musicMicrophone2
